import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccProspect } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { AdmissionsAreaService } from '../../../../admissions-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService, admissionsAreaService: AdmissionsAreaService): GridSetup<AccProspect> {

	return {
		rowName: { singular: 'Prospect', plural: 'Prospects' },
		getRowKey: row => '' + row.accProspectId,
		stateKey: 'prospects-all-prospects-grid',
		actions: getActions(dialogService, admissionsAreaService),
		buttons: [],
		columns: getColumns(util, domainData, app),
	}
}
